import * as Yup from "yup";
/* eslint-disable no-useless-escape */
const ChangeEmailValidation = (t) => {
  return Yup.object().shape({
    email: Yup.string()
      .required(t("auth.email.required"))
      .matches(
        /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/,
        t("auth.email.validMessage")
      ),
  });
};
export default ChangeEmailValidation;
